import { LEARNING_DEVELOPMENT } from '@app/shared/constants/learning-development.constants';

/**
 * Column definitions for the learning development grid
 */
export const learningDevelopmentColumnDefs = [
  { field: 'name', headerName: LEARNING_DEVELOPMENT.COLUMNS.NAME, sortable: true },
  { field: 'quarter', headerName: LEARNING_DEVELOPMENT.COLUMNS.QUARTER, sortable: true },
  { field: 'tenHrsTraining', headerName: LEARNING_DEVELOPMENT.COLUMNS.TRAINING, sortable: true },
  { field: 'numberOfCertificationRequired', headerName: LEARNING_DEVELOPMENT.COLUMNS.CERTIFICATION, sortable: true },
  { field: 'upskilledToFullstack', headerName: LEARNING_DEVELOPMENT.COLUMNS.FULLSTACK, sortable: true },
  { field: 'aiMlAndGenAiSkills', headerName: LEARNING_DEVELOPMENT.COLUMNS.AI_SKILLS, sortable: true }
];

/**
 * Pagination configuration for the learning development grid
 */
export const learningDevelopmentPaginationParams = { 
  enabled: LEARNING_DEVELOPMENT.PAGINATION.ENABLED, 
  pageSize: LEARNING_DEVELOPMENT.PAGINATION.DEFAULT_PAGE_SIZE, 
  pageSizeOptions: LEARNING_DEVELOPMENT.PAGINATION.PAGE_SIZE_OPTIONS 
};

/**
 * Transforms the raw API data to display format
 * Converting boolean values to Yes/No strings
 */
export const transformToDisplayData = (data: any[]): any[] => {
  return data.map(item => ({
    ...item,
    upskilledToFullstack: item.upskilledToFullstack === true ? LEARNING_DEVELOPMENT.TEXT.YES : LEARNING_DEVELOPMENT.TEXT.NO,
    aiMlAndGenAiSkills: item.aiMlAndGenAiSkills === true ? LEARNING_DEVELOPMENT.TEXT.YES : LEARNING_DEVELOPMENT.TEXT.NO,
    tenHrsTraining: item.tenHrsTraining === LEARNING_DEVELOPMENT.TEXT.YES ? LEARNING_DEVELOPMENT.TEXT.YES : LEARNING_DEVELOPMENT.TEXT.NO
  }));
};
